import React, { useEffect, useState } from "react"

import { t } from "i18next";
import { ISponsors, ISponsorsData, ISponsorsDataPerson } from "../../../interfaces/event/sponsors"
import colors from "../../../theme/colors";
import { breakpointSize } from "../../../theme/mediaQuerie";
import { Card } from "../../shared-v2/Card";
import { Subtitle } from "../../shared-v2/Subtitle";
import { Tag } from "../../shared-v2/Tag";
import { IFile, UploadImage } from "../../shared-v2/UploadImage";
import BaseToggle from "../../shared/BaseToggle";
import Button from "../../shared/button/Button";
import Input from "../../shared/input/Input";
import PageTitle from "../../shared/pageTitle/PageTitle";
import Typography from "../../shared/typography/Typography";
import { CardContent, Column, FormContainer, InputGroup, ListGroups, ListSponsors, NewGroupContainer, Row, RowGrid, ToggleContainer } from "./style";

interface IProps {
  sponsors: ISponsors;
  setSponsors: React.Dispatch<React.SetStateAction<ISponsors>>;
}

const isMobile = window.innerWidth <= breakpointSize.Sm;

const SponsorCard = ({sponsor, sponsorGroup, onDelete, index }: {sponsor: ISponsorsDataPerson, sponsorGroup: string, onDelete: () => void, index: number}) => (
  <Card
    style={index !== 0 ? { marginTop: '16px' } : {}}
    customBackground="background"
    onDelete={onDelete}
    title={`${t("dashboard.event.sponsor.cardTitle", {'index': index+1, 'group': sponsorGroup})}`}
    key={sponsor.link}
  >
    <CardContent>
      <div>
        <img style={{ maxWidth: "50%" }} src={sponsor.logo} alt={`Sponsor ${index + 1}`} />
      </div>
      <div>
        <Typography color="body" type="headingXXS">{t("link") + ": "}</Typography>
        <Typography color="body" type="paragraphXS">{sponsor.link}</Typography>
      </div>
    </CardContent>
  </Card>
);

export const Sponsors = ({sponsors, setSponsors}: IProps) => {
  const [newSponsor, setNewSponsor] = useState<ISponsorsDataPerson>({
    logo: "",
    link: "",
  });
  const [newGroup, setNewGroup] = useState("");
  const [selectedGroup, setSelectedGroup] = useState<{title: string, index: number}>();
  const [file, setFile] = useState<IFile | null>(null);

  useEffect(() => {
    if (selectedGroup && selectedGroup.index >= sponsors.itens.length) {
      setSelectedGroup(undefined);
    }
  }, [sponsors, selectedGroup]);

  const updateSponsors = (attr: keyof ISponsors, value: boolean) => {
    setSponsors(prev => ({...prev, [attr]: value}));
  }
  

  const updateNewGroup = (attr: keyof ISponsorsData, value: string) => {
    setNewGroup(value);
  }

  const updateNewSponsor = (attr: keyof ISponsorsDataPerson  , value: string) => {
    setNewSponsor(prev => ({...prev, [attr]: value}));
  }

  const handleAddGroup = () => {
    let newItens = sponsors.itens;
    newItens.push({title: newGroup, list: []});
    setSponsors(prev => ({...prev, itens: newItens}));

    if(newItens.length === 1) {
      setSelectedGroup({title: newGroup, index: 0});
    }

    setNewGroup("");
  }

  const handleRemoveGroup = (index: number) => {
    let newItens = sponsors.itens;
    newItens.splice(index, 1);
    setSponsors(prev => ({...prev, itens: newItens}));
  }

  const handleAddSponsor = () => {
    if(!selectedGroup) return;

    let newList = sponsors.itens[selectedGroup.index].list;
    newList.push(newSponsor);
    let newItens = sponsors.itens;
    newItens[selectedGroup.index].list = newList;
    setSponsors(prev => ({...prev, itens: newItens}));

    setNewSponsor((previous) => {
      return { ...previous, logo: "", link: ""};
    });

    setFile(null);
  }

  const handleRemoveSponsor = (indexGroup: number, indexSponsor: number) => {

    let newList = sponsors.itens[indexGroup].list;
    newList.splice(indexSponsor, 1);

    let newItens = sponsors.itens;
    newItens[indexSponsor].list = newList;
  
    setSponsors(prev => ({...prev, itens: newItens}));
  }

  const getToolTipAddSponsor = () => {
    console.log(sponsors.itens);

    if(sponsors.itens.length === 0) return t("dashboard.event.sponsor.tooltip.noGroupRegistered"); //"Nenhum grupo criado"
    if(selectedGroup && selectedGroup.title.trim() === "") return t("dashboard.event.sponsor.tooltip.noGroupSelected"); //"É necessário atribuir à algum grupo"
    if(selectedGroup && sponsors.itens.findIndex(item => item.title === selectedGroup.title) === -1)
      return t("dashboard.event.sponsor.tooltip.groupNonexistent"); //"O grupo selecionado não existe"
    if(newSponsor.logo === "") return t("dashboard.event.sponsor.tooltip.logoRequired"); //"A logo é obrigatória"
    return "";
  }

  return (
    <>
       <Row>
        { !isMobile && <PageTitle style={{margin: 0}}>{t("dashboard.event.sponsors.title")}</PageTitle> }
        <ToggleContainer>
          <Typography type="paragraphS" color="title">{t("dashboard.event.displaySection")}</Typography>
          <BaseToggle
            initialCheck={sponsors.menu ?? false} 
            onChange={(checked: boolean) => updateSponsors("menu", checked)} 
          />
        </ToggleContainer>
      </Row>

      <RowGrid>
        <Column>
          <NewGroupContainer>
            <InputGroup>
              <Subtitle>{t("tierTitle")}</Subtitle>
              <Input
                placeholder={t("dashboard.event.sponsors.tier.placeholder")!} 
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateNewGroup("title", e.target.value)}
                value={newGroup} 
              />
            </InputGroup>
            <Button
              onClick={handleAddGroup} 
              size="small"
              style={{padding: '8px 64px', margin: '0 auto'}}
              variant="primary"
              typographyType="paragraphXXS"
              enable={newGroup.trim() !== ""}
              fullWidth={isMobile}
              tooltip={newGroup.trim() !== "" ? "" : t("dashboard.event.sponsors.tooltipTier")!}
            >
              {t("save")}
            </Button>
          </NewGroupContainer>

          {isMobile && (
            <>
              <Subtitle>{t("tier")}</Subtitle>
              <ListGroups>
                {sponsors.itens.length > 0 && (
                sponsors.itens.map((item: ISponsorsData, index: number) => (
                  <Tag
                    title={item.title} 
                    onRemove={() => {handleRemoveGroup(index)}} 
                    onSelect={() => setSelectedGroup(prev => (
                      selectedGroup?.index === index ? undefined : {title: item.title, index: index}
                    ))} 
                    key={index}
                    selected={selectedGroup?.index === index}
                  />
                )))}
              </ListGroups>
           </>
          )}

          <FormContainer>
            <InputGroup>
              <UploadImage 
                id="sponsors-upload-image" 
                maxImageSize={1024 * 1024 * 10}
                file={file} 
                setFile={(file) => {updateNewSponsor("logo", file?.url ?? ""); setFile(file)}}
                title={t("image")} 
                style={isMobile ? {backgroundColor: colors.line} : {}}
              />
              <Subtitle>{t("group")}</Subtitle>
              <Input 
                placeholder={t("dashboard.event.sponsor.group.placeholder")!}
                value={selectedGroup?.title ?? ""} 
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                  { setSelectedGroup({
                    title: e.target.value, 
                    index: sponsors.itens.findIndex(item => item.title === e.target.value) ?? -1
                  })}} 
              />
              <Subtitle>{t("link")}</Subtitle>
              <Input 
                placeholder={t("dashboard.event.sponsor.link.placeholder")!}
                value={newSponsor.link} 
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                  {updateNewSponsor("link", e.target.value)}} 
              />
            </InputGroup>
            <Button 
              tooltip={getToolTipAddSponsor()}
              enable={selectedGroup !== undefined && selectedGroup.index !== -1 && newSponsor.logo.trim() !== ""}
              style={{padding: '8px 64px', margin: '16px auto 0 auto'}}
              size="small"
              typographyType="paragraphXXS"
              onClick={handleAddSponsor}
              variant="primary"
              fullWidth={isMobile}
            >
              {t("add")}
            </Button>
          </FormContainer>
        </Column>

        <Column>
         {!isMobile && (
           <>
            <Subtitle>{t("tier")}</Subtitle>
            <ListGroups>
              {sponsors.itens.length > 0 && (
              sponsors.itens.map((item: ISponsorsData, index: number) => (
                <Tag
                  title={item.title} 
                  onRemove={() => {handleRemoveGroup(index)}} 
                  onSelect={() => setSelectedGroup(prev => (
                    selectedGroup?.index === index ? undefined : {title: item.title, index: index}
                  ))} 
                  key={item.title}
                  selected={selectedGroup?.index === index}
                />
              )))}
            </ListGroups>
           </>
         )}

          <ListSponsors>
            {selectedGroup && sponsors.itens[selectedGroup.index] ? (
              sponsors.itens[selectedGroup.index].list.length > 0 ? (
                sponsors.itens[selectedGroup.index].list.map((sponsor, index) => (
                  <SponsorCard
                    sponsor={sponsor}
                    sponsorGroup={selectedGroup.title}
                    onDelete={() => handleRemoveSponsor(selectedGroup.index, index)}
                    index={index}
                    key={sponsor.link}
                  />
                ))
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '170px' }}>
                  <Typography type="paragraphS" color="label">
                    {t("dashboard.event.sponsors.noSponsor")}
                  </Typography>
                </div>
              )
            ) : (
              sponsors.itens.map((group, indexGroup) => (
                group.list.map((sponsor, indexSponsor) => (
                  <SponsorCard
                    sponsor={sponsor}
                    sponsorGroup={group.title}
                    onDelete={() => handleRemoveSponsor(indexGroup, indexSponsor)}
                    index={indexSponsor}
                    key={sponsor.link}
                  />
                ))
              ))
            )}
          </ListSponsors>
        </Column>
      </RowGrid>
    </>
  );
}